import React from 'react';

function ChatTwo(props: object) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.61425 13.0035L3.72909 13.2897C4.03636 14.0556 4.375 15.1306 4.375 16.25C4.375 16.6985 4.3205 17.1414 4.23466 17.5619C4.62046 17.4307 5.01761 17.2699 5.41147 17.073C6.0986 16.7294 6.67451 16.3264 7.13742 15.9401L7.78089 15.4033L8.61011 15.5245C9.06064 15.5905 9.52493 15.625 10 15.625C14.7304 15.625 18.125 12.3196 18.125 8.75C18.125 5.18039 14.7304 1.875 10 1.875C5.26967 1.875 1.875 5.18039 1.875 8.75C1.875 10.2272 2.42786 11.6165 3.41379 12.7691L3.61425 13.0035ZM3.51687 19.7066C2.2012 20 1.25 20 1.25 20C1.25 20 1.79153 19.1371 2.16171 18.0459C2.35396 17.4792 2.5 16.851 2.5 16.25C2.5 15.4782 2.25916 14.6615 1.98892 13.9879C0.739806 12.5276 0 10.7144 0 8.75C0 3.91751 4.47715 0 10 0C15.5229 0 20 3.91751 20 8.75C20 13.5825 15.5229 17.5 10 17.5C9.43401 17.5 8.87901 17.4589 8.33867 17.3797C7.78224 17.8441 7.08601 18.332 6.25 18.75C5.29208 19.229 4.33416 19.5244 3.51687 19.7066Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChatTwo;
